"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconTextInput = void 0;
var _react = _interopRequireDefault(require("react"));
var AccessibleIcon = _interopRequireWildcard(require("@radix-ui/react-accessible-icon"));
var _Icons = require("../Icons.constants");
var _IconModule = _interopRequireDefault(require("../Icon.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var IconTextInput = _ref => {
  var className = _ref.className,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? _Icons.DEFAULT_LABEL : _ref$label,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? _Icons.DEFAULT_COLOR : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _Icons.DEFAULT_SIZE : _ref$size,
    _ref$isFilled = _ref.isFilled,
    isFilled = _ref$isFilled === void 0 ? false : _ref$isFilled;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: size,
      width: size
    },
    className: (0, _classnames.default)(className, _IconModule.default.Container)
  }, /*#__PURE__*/_react.default.createElement(AccessibleIcon.Root, {
    label: label
  }, isFilled ? /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 4L14.5 4C13.9477 4 13.5 3.55228 13.5 3C13.5 2.44772 13.9477 2 14.5 2L16.9968 2.00001L17 2L17.0032 2.00001L19.5 2.00001C20.0523 2.00001 20.5 2.44773 20.5 3.00001C20.5 3.5523 20.0523 4.00001 19.5 4.00001L18 4.00001V6L18.8385 6C19.3657 5.99998 19.8205 5.99997 20.195 6.03057C20.5904 6.06287 20.9836 6.13419 21.362 6.32698C21.9265 6.6146 22.3854 7.07354 22.673 7.63803C22.8658 8.01641 22.9371 8.40963 22.9694 8.80497C23 9.17955 23 9.63431 23 10.1615V13.8385C23 14.3657 23 14.8205 22.9694 15.195C22.9371 15.5904 22.8658 15.9836 22.673 16.362C22.3854 16.9265 21.9265 17.3854 21.362 17.673C20.9836 17.8658 20.5904 17.9371 20.195 17.9694C19.8205 18 19.3658 18 18.8387 18H18V20L19.5 20C20.0523 20 20.5 20.4477 20.5 21C20.5 21.5523 20.0523 22 19.5 22L14.5 22C13.9477 22 13.5 21.5523 13.5 21C13.5 20.4477 13.9477 20 14.5 20L16 20L16 4Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.16146 6H13C13.5523 6 14 6.44772 14 7V17C14 17.5523 13.5523 18 13 18H5.16148C4.63441 18 4.1795 18 3.80498 17.9694C3.40963 17.9371 3.01641 17.8658 2.63803 17.673C2.07355 17.3854 1.6146 16.9265 1.32698 16.362C1.13419 15.9836 1.06287 15.5904 1.03057 15.195C0.999971 14.8205 0.999985 14.3657 1 13.8386V10.1615C0.999985 9.63434 0.999971 9.17953 1.03057 8.80497C1.06287 8.40963 1.13419 8.01641 1.32698 7.63803C1.6146 7.07354 2.07355 6.6146 2.63803 6.32698C3.01641 6.13419 3.40963 6.06287 3.80498 6.03057C4.17953 5.99997 4.63434 5.99998 5.16146 6Z",
    fill: color
  })) : /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M13 7H5.2C4.0799 7 3.51984 7 3.09202 7.21799C2.71569 7.40973 2.40973 7.71569 2.21799 8.09202C2 8.51984 2 9.0799 2 10.2V13.8C2 14.9201 2 15.4802 2.21799 15.908C2.40973 16.2843 2.71569 16.5903 3.09202 16.782C3.51984 17 4.07989 17 5.2 17H13M17 7H18.8C19.9201 7 20.4802 7 20.908 7.21799C21.2843 7.40973 21.5903 7.71569 21.782 8.09202C22 8.51984 22 9.0799 22 10.2V13.8C22 14.9201 22 15.4802 21.782 15.908C21.5903 16.2843 21.2843 16.5903 20.908 16.782C20.4802 17 19.9201 17 18.8 17H17M17 21L17 3M19.5 3.00001L14.5 3M19.5 21L14.5 21",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
exports.IconTextInput = IconTextInput;
//# sourceMappingURL=IconTextInput.js.map